/**
 * EMZI NEXUS V6.4 - Live Studio V2
 * Step 6: Evidence Mode
 */

import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { Card, CardContent } from '../../../components/ui/card';
import { EMZI_SPACING, EMZI_RADIUS } from '../../../styles/emziCI';

const EVIDENCE_MODES = [
  {
    id: 'scientific',
    icon: '🔬',
    name: { en: 'Scientific', ms: 'Saintifik', bm: 'Saintifik', urban: 'Scientific' },
    desc: { en: 'Data, studies, and facts to build credibility', ms: 'Data, kajian, dan fakta untuk bina kredibiliti', bm: 'Data, kajian, dan fakta untuk bina kredibiliti', urban: 'Data, studies, dan facts untuk build credibility' }
  },
  {
    id: 'emotional',
    icon: '💝',
    name: { en: 'Emotional', ms: 'Emosi', bm: 'Emosi', urban: 'Emotional' },
    desc: { en: 'Stories and experiences for emotional connection', ms: 'Cerita dan pengalaman untuk hubung emosi', bm: 'Cerita dan pengalaman untuk hubung emosi', urban: 'Stories dan experiences untuk emotional connection' }
  },
  {
    id: 'hybrid',
    icon: '🔀',
    name: { en: 'Hybrid', ms: 'Hibrid', bm: 'Hibrid', urban: 'Hybrid' },
    desc: { en: 'Balance facts with emotions for versatility', ms: 'Gabung fakta dengan emosi untuk fleksibel', bm: 'Gabung fakta dengan emosi untuk fleksibel', urban: 'Balance facts dengan emotions untuk versatility' }
  }
];

const Step6Evidence = ({ sessionId, sessionData, onComplete, onBack, setError }) => {
  const { language } = useLanguage();
  const [evidenceMode, setEvidenceMode] = useState(sessionData?.evidenceMode || null);

  const handleContinue = () => {
    if (!evidenceMode) {
      setError(language === 'bm' ? 'Sila pilih mod bukti' : 'Please select an evidence mode');
      return;
    }
    setError(null);
    onComplete({ evidenceMode });
  };

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ marginBottom: EMZI_SPACING.xl, textAlign: 'center' }}>
        <h1 style={{ fontSize: '22px', fontWeight: '700', marginBottom: EMZI_SPACING.sm, color: '#fff' }}>📋 Evidence Mode</h1>
        <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.9)' }}>
          {language === 'bm' ? 'Macam mana nak tunjuk bukti?' : 'How should we present proof?'}
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {EVIDENCE_MODES.map(mode => (
          <Card
            key={mode.id}
            onClick={() => setEvidenceMode(mode.id)}
            style={{
              cursor: 'pointer',
              borderRadius: EMZI_RADIUS.md,
              border: evidenceMode === mode.id ? '3px solid #F89B29' : '2px solid transparent',
              background: evidenceMode === mode.id ? '#FFF5E6' : '#fff',
              transition: 'all 0.2s'
            }}
          >
            <CardContent style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ fontSize: '40px' }}>{mode.icon}</div>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                  {mode.name[language] || mode.name.en}
                </h3>
                <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
                  {mode.desc[language] || mode.desc.en}
                </p>
              </div>
              {evidenceMode === mode.id && (
                <div style={{ marginLeft: 'auto', fontSize: '24px', color: '#F89B29' }}>✓</div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
        <button onClick={onBack} style={{ flex: 1, padding: '14px', background: '#fff', border: '2px solid #0e67a2', borderRadius: '10px', color: '#0e67a2', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>← Back</button>
        <button onClick={handleContinue} style={{ flex: 2, padding: '14px', background: '#F7941E', border: 'none', borderRadius: '10px', color: '#fff', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>Continue to Review →</button>
      </div>
    </div>
  );
};

export default Step6Evidence;
